import type { ComponentProps } from "react";
import { cn } from "../../utils/format";

type BadgeProps = ComponentProps<"span"> & {
  variant?: "soft" | "solid" | "dark" | "outline";
};

const VARIANTS = {
  soft: "bg-primary-soft text-primary",
  solid: "bg-primary text-night",
  dark: "bg-night/80 text-white backdrop-blur",
  outline: "border border-line text-muted",
} as const;

export const Badge = ({ variant = "soft", className, ...props }: BadgeProps) => (
  <span
    className={cn(
      "inline-flex items-center gap-1 rounded-full px-3 py-1 text-[11px] font-semibold uppercase tracking-wider",
      VARIANTS[variant],
      className,
    )}
    {...props}
  />
);
